import React, { Component } from 'react';
import { View, Picker } from 'react-native';

import styles from './styles';

const { Item } = Picker;

class ChangeStatus extends Component {
    changeStatusPedido = (id) => {
        this.setState({
            currentStatus: id
        });

        this.props.onStatusChange(id);
    };

    render() {
        const { statusList = [], currentStatus = '' } = this.props;
        const CANCELADO = 6;

        return (
            <View>
                <Picker
                    selectedValue={currentStatus}
                    onValueChange={this.changeStatusPedido}
                    mode="dropdown"
                    enabled={currentStatus !== CANCELADO}
                    style={styles.picker}
                >
                    {currentStatus !== CANCELADO &&
                        statusList.map((status) => (
                            <Item
                                key={status.idStatusPedido}
                                label={status.dsStatusPedido}
                                value={status.idStatusPedido}
                            />
                        ))}
                    {currentStatus === CANCELADO && (
                        <Item label={'Cancelado'} />
                    )}
                </Picker>
            </View>
        );
    }
}

export default ChangeStatus;
